<template>
    <div class="filter-panel panel">
        <div class="title">Kupon Detayları</div>
        <div class="content">
          <div class="report">
            <div class="item">
              <span>Kupon Durumu:</span>
              <b :class="'text-' + status_id">{{ status }}</b>
            </div>
            <div class="item">
              <span>Bahis Tutarı:</span>
              <b>{{ bet }} TRY</b>
            </div>
            <div class="item">
              <span>Kazanç:</span>
              <b>{{ win }} TRY</b>
            </div>
            <div class="item">
              <span>Toplam Oran:</span>
              <b>{{ odd }}</b>
            </div>
            <div class="item">
              <span>Kupon Tarihi:</span>
              <b>{{ time }}</b>
            </div>
          </div>
          <button class="button secondary back" @click="back()">Kuponlara Geri Dön</button>
        </div>
    </div>
</template>
<script>
  export default{
    props:['status', 'status_id', 'bet', 'win', 'odd','time','back']
  }
</script>